import { getRouteApi } from "@tanstack/react-router";
import { MasterDataMappingsTable } from "@/components/master-data-mappings/MasterDataMappingsTable";
import { isMasterDataEntityType } from "@/lib/enums";

const routeApi = getRouteApi("/dashboard/master-data-mappings/$entityType");

export function MasterDataMappingsEntityPage() {
  const { entityType } = routeApi.useParams();
  // `beforeLoad` (router.tsx) already redirects invalid values away — this
  // narrows the type without an unsafe cast, per .claude/rules/code-quality.md.
  if (!isMasterDataEntityType(entityType)) return null;
  return <MasterDataMappingsTable entityType={entityType} />;
}
